export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";